export default __webpack_public_path__ + "static/media/portfolio-188.f0a81553.jpg";